import { CommentDto } from "../../api/Api";
import { buildCommentDto } from "../../utils/commentUtils";
import { Progress } from "./departmentProgress/utils";

type FormWithComments = {
  comments: CommentDto[];
};

export type LifecycleAction = "save" | "complete";

type LifecycleActionsArgs<TForm extends FormWithComments, TEntity> = {
  formData: TForm;
  currentComment: string;
  currentProgress: string | undefined;
  canSetInProgress: boolean;
  buildEntity: (
    formData: TForm & { complete?: boolean },
    progress: string | undefined,
    action: LifecycleAction
  ) => TEntity;
  mutate: (entity: TEntity) => void;
};

export const createLifecycleActions = <
  TForm extends FormWithComments,
  TEntity
>({
  formData,
  currentComment,
  currentProgress,
  canSetInProgress,
  buildEntity,
  mutate
}: LifecycleActionsArgs<TForm, TEntity>) => {
  const persist = (action: LifecycleAction) => {
    const trimmedComment = currentComment.trim();
    const updatedForm = {
      ...formData,
      comments: trimmedComment
        ? [...formData.comments, buildCommentDto(trimmedComment)]
        : formData.comments,
      // Save must not clear a completion flag already stored on the lifecycle.
      ...(action === "complete" ? { complete: true } : {})
    };
    const progress =
      action === "complete"
        ? Progress.Completed
        : canSetInProgress
          ? Progress.InProgress
          : currentProgress;

    mutate(buildEntity(updatedForm, progress, action));
  };

  return {
    handleSave: () => persist("save"),
    handleComplete: () => persist("complete")
  };
};
